import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Close from '@material-ui/icons/Close';
import Button from '$components/Button';

import { Header, Title, Content, SubTitle } from './Panel.styled';

const Panel = ({ open, children, title, onClose, subTitle }) => (
  <Drawer open={open} onClose={onClose}>
    <Header>
      <div>
        <Title data-testid="panel-title">{title}</Title>
        {subTitle && (
          <SubTitle data-testid="panel-subtitle">{subTitle}</SubTitle>
        )}
      </div>
      <Button
        size="iconLarge"
        look="iconTransparentCircle"
        onClick={onClose}
        label="Close"
        testId="close-button"
      >
        <Close />
      </Button>
    </Header>
    <Content data-testid="panel-content">{children}</Content>
  </Drawer>
);

Panel.defaultProps = {
  subTitle: null,
};

Panel.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default Panel;
